import { IsServerSideRendering } from '@utilities';
import { checkIfDismissedCookieExists, shouldDisplayOnPage } from '@utilities/bannersAndModals';
import theme from '@theme';
import { ACCOUNT_MODAL } from '@constants';
import { openModal, createAccount } from '@Header/Modals/ducks/actions';
import qs from 'qs';

export const handleOpenModalAction = (modalName, event) => dispatch => {
  const { openAccountModal } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const isAccountModal = modalName === ACCOUNT_MODAL || openAccountModal;
  if (isAccountModal) {
    dispatch(createAccount(event.detail));
  }
  dispatch(openModal(modalName, event?.detail));
};

export const handleDelayedModals = () => async (dispatch, getState) => {
  if (IsServerSideRendering) return;
  const reduxState = await getState();
  const {
    header: { enabledPromotions }
  } = reduxState;

  for (let i = 0; i <= enabledPromotions?.length; i += 1) {
    const promotion = enabledPromotions[i];
    if (!promotion || !promotion.modal) break;

    const {
      modal: {
        cookieName,
        showOnLoad,
        showOnLoadDesktopMinWidth,
        showOnLoadDesktopDelay,
        showOnLoadMobileDelay,
        includedPages,
        excludedPages
      }
    } = promotion;

    if (!showOnLoad) break;
    if (checkIfDismissedCookieExists(cookieName)) break;

    const shouldDisplayOnCurrentPage = shouldDisplayOnPage(
      includedPages,
      excludedPages
    );
    if (!shouldDisplayOnCurrentPage) break;

    // eslint-disable-next-line
    const isDesktop =
      screen.width >=
      (showOnLoadDesktopMinWidth || theme.breakpoints.values.sm);
    const delayOnDesktop = isDesktop && showOnLoadDesktopDelay;
    if (delayOnDesktop) {
      setTimeout(() => {
        dispatch(openModal(promotion.name));
      }, showOnLoadDesktopDelay);
      break;
    }

    const delayOnMobile = !isDesktop && showOnLoadMobileDelay;
    if (delayOnMobile) {
      setTimeout(() => {
        dispatch(openModal(promotion.name));
      }, showOnLoadMobileDelay);
      break;
    }
  }
};
